import React from 'react'
import { Link } from 'react-router-dom';
const PortfolioBanner = () => {
    const style = {
        position: 'relative',
        zIndex: '1',
        background: 'transparent url(../img/all-banner/portfolio-banners.webp) right top no - repeat',
        paddingTop: '160px',
        paddingBottom: '160px',
        textAlign: 'center',
        top: '0',
        backgroundPosition: 'center',
        backgroundSize: ' 100 % 100 %',
    }
    return (
        <>
            {/* <div className="portfolio-banner" >
                <div className="d-table">
                    <div className="d-table-cell">
                        <div className="container">
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="bread-internal-cls">
                <div className="container">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/services">Services</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Portfolio
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
        </>
    )
}

export default PortfolioBanner